import React, { useState, useEffect } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, addDoc, getDocs, query, where, doc, deleteDoc } from "firebase/firestore";


import { jsPDF } from "jspdf";
import * as XLSX from 'xlsx';
import './body.css';

const db = getFirestore();


const Body = () => {

  const [selectedOption, setSelectedOption] = useState("home"); // Default to "home"
  const [userDetails, setUserDetails] = useState(null); // Define userDetails state
  const auth = getAuth(); // Initialize Firebase Auth
  const navigate = useNavigate(); // Initialize navigate
  const db = getFirestore(); // Initialize Firestore


// to create invoice
  const [to, setTo] = useState(""); // To field
  const [date, setDate] = useState(""); // Date field
  const [description, setDescription] = useState(""); // Description field
  const [amount, setAmount] = useState(""); // Amount field
  const [totalAmount, setTotalAmount] = useState(0); // Total amount
  const [invoiceNumber, setInvoiceNumber] = useState(""); // Start Invoice No 
  const [deductAmount, setDeductAmount] = useState(""); // New state for deduct amount



//01 create invoice
const handleCreateInvoice = async () => {
  if (!to || !date || !description || !amount || !invoiceNumber || deductAmount === undefined) {
      window.alert("Please fill in all required fields before proceeding!"); // Show alert to user
      return;
  }

  const totalAmount = parseFloat(amount) - parseFloat(deductAmount); // Calculate total amount after deduction

  const invoiceData = {
      to: String(to).trim(),
      date: String(date).trim(),
      description: String(description).trim(),
      amount: parseFloat(amount) || 0,
      deductAmount: parseFloat(deductAmount) || 0, // Deduct amount field
      totalAmount: totalAmount || 0,
      invoiceNo: invoiceNumber,
      createdAt: new Date(),
  };

  console.log("Invoice Data:", invoiceData); // Debugging

  try {
      await addDoc(collection(db, "invoices"), invoiceData);

      // Create a PDF with A5 landscape size
      const doc = new jsPDF({
          orientation: "landscape",
          unit: "mm",
          format: [210, 148], // A5 in landscape mode
      });

      const logo = "/hero.png"; // Ensure this path is correct

      // --- Header ---
      doc.setFillColor(21, 27, 84);
      doc.rect(0, 0, doc.internal.pageSize.getWidth(), 30, "F"); // Adjusted height for A5 landscape
      doc.addImage(logo, "PNG", 10, 5, 20, 20);
      doc.setFontSize(14);
      doc.setTextColor(255, 255, 255);
      doc.text("HERO CLEANING SERVICES", 80, 12);
      doc.setFontSize(10);
      doc.text("No.20/5 A, Frazer Avenue, 1st Lane, Moratuwa", 80, 18);
      doc.text("Reg: W/H 14179", 80, 24);

      // --- INVOICE Title ---
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(0, 0, 0);
      doc.text("INVOICE", doc.internal.pageSize.getWidth() / 2, 40, { align: "center" });

    
        // --- Invoice Details ---
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.text("To:", 10, 55);

      // Split the address by newlines and print each line separately
      const addressLines = invoiceData.to.split('\n');
      addressLines.forEach((line, index) => {
        doc.text(line, 20, 55 + (index * 5)); // 5 units spacing between lines
      });


      doc.text(`Invoice: ${invoiceNumber}`, doc.internal.pageSize.getWidth() - 10, 55, { align: "right" });
      // doc.text(`Date: ${invoiceData.date}`, doc.internal.pageSize.getWidth() - 10, 62, { align: "right" });

        // Format the date as DD-MM-YYYY
        const formattedDate = formatDate(invoiceData.date); // Using a helper function
        doc.text(
          `Date: ${formattedDate}`,
          doc.internal.pageSize.getWidth() - 10,
          62,
          { align: "right" }
        );

        // Helper function to format date as DD-MM-YYYY
        function formatDate(dateInput) {
          const date = new Date(dateInput);
          const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits (e.g., 05)
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
}




      // --- Table ---
      let currentY = 75;
      doc.line(10, currentY, doc.internal.pageSize.getWidth() - 10, currentY); // Horizontal line
      currentY += 7;

      // Table Headers
      doc.setFontSize(10);
      doc.setFont("helvetica", "bold");
      doc.text("Description", 10, currentY);
      doc.text("Amount", doc.internal.pageSize.getWidth() - 10, currentY, { align: "right" });

      // Move to next line
      currentY += 7;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      currentY += 10; 
      doc.text(invoiceData.description, 10, currentY);
      doc.text(`Rs.${invoiceData.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, currentY, { align: "right" });

      currentY += 12;

      // Deduct Amount
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text("Deduction Amount", 10, currentY);
      doc.text(`Rs.${invoiceData.deductAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, currentY, { align: "right" });

      currentY += 7;

      // Total Amount
      doc.setFont("helvetica", "bold");
      doc.text("Total Amount", 10, currentY + 10);
      doc.text(`Rs.${invoiceData.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, currentY + 10, { align: "right" });
      doc.setFont("helvetica", "normal");
      // --- Footer ---
      doc.setFillColor(255, 170, 29);
      doc.rect(0, doc.internal.pageSize.getHeight() - 15, doc.internal.pageSize.getWidth(), 15, "F");
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);
      doc.text("Contact No: 075 90 66 636 / 077 6066 636", 10, doc.internal.pageSize.getHeight() - 7);
      doc.text("Email: 1heroclean@gmail.com", 10, doc.internal.pageSize.getHeight() - 3);

      // Save the PDF
      doc.save(`Invoice-${invoiceNumber}.pdf`);

      setInvoiceNumber(invoiceNumber);
      setTo("");
      setDate("");
      setDescription("");
      setAmount("");
      setDeductAmount(0); // Reset deduct amount
  } catch (error) {
      console.error("Error creating invoice: ", error);
  }
};


// 02 to craete salary 

 // State declarations
 const [employeeName, setEmployeeName] = useState("");
 const [salaryMonth, setSalaryMonth] = useState("January");
 const [epfNo, setEpfNo] = useState("");
 const [nicNo, setNicNo] = useState("");
 const [designation, setDesignation] = useState("");
 const [site, setSite] = useState("");
 const [workedDays, setWorkedDays] = useState(1);
 const [paymentMethod, setPaymentMethod] = useState("Cash");
 const [salaryAdvance, setSalaryAdvance] = useState(0);
 const [uniformDeduction, setUniformDeduction] = useState(0);
 const [siteRate, setSiteRate] = useState(1153.85);
 const [dailyAllowance, setDailyAllowance] = useState(0);
 const [otherAllowance, setOtherAllowance] = useState(0);
 const [ot, setOt] = useState(0);
 const [siteAllowance, setSiteAllowance] = useState(0);
 const [epfSalary, setEpfSalary] = useState(0);
 const [grossSalary, setGrossSalary] = useState(1800);
 const [epf8, setEpf8] = useState(0);
 const [epf12, setEpf12] = useState(0);
 const [etf3, setEtf3] = useState(0);
 const [netSalary, setNetSalary] = useState(0);
 const [otHours, setOtHours] = useState(0);
 const [otRate, setOtRate] = useState(202);

 // Calculations
 useEffect(() => {
  const workedDaysNum = parseFloat(workedDays) || 0;
  const otHoursNum = parseFloat(otHours) || 0;

  const calculatedEpfSalary = workedDaysNum * siteRate; // Correct EPF salary calculation
  const calculatedGrossSalary = 1800 * workedDaysNum;
  const calculatedOt = otHoursNum * otRate;
  const calculatedSiteSpecificAllowance = calculatedGrossSalary - (calculatedEpfSalary  + calculatedOt);

  const calculatedEpf8 = calculatedEpfSalary * 0.08;
  const calculatedEpf12 = calculatedEpfSalary * 0.12;
  const calculatedEtf3 = calculatedEpfSalary * 0.03;
  const calculatedNetSalary = calculatedGrossSalary - (calculatedEpf8 + salaryAdvance + uniformDeduction);

  setEpfSalary(calculatedEpfSalary);
  setGrossSalary(calculatedGrossSalary);
  setOt(calculatedOt);
  setSiteAllowance(calculatedSiteSpecificAllowance);
  setEpf8(calculatedEpf8);
  setEpf12(calculatedEpf12);
  setEtf3(calculatedEtf3);
  setNetSalary(calculatedNetSalary);
}, [workedDays, otHours, siteRate, dailyAllowance, otherAllowance, salaryAdvance, uniformDeduction, otRate]);

 

 const handleGenerateSalary = async (e) => {
   e.preventDefault();
   
   const salaryData = {
     employeeName,
     salaryMonth,
     epfNo,
     nicNo,
     designation,
     site,
     workedDays,
     siteRate,
     dailyAllowance,
     otherAllowance,
     epfSalary,
     ot,
     siteAllowance,
     grossSalary,
     epf8,
     salaryAdvance,
     uniformDeduction,
     netSalary,
     epf12,
     etf3,
     paymentMethod,
     createdAt: new Date(),
   };

   try {
     await addDoc(collection(db, "salaries"), salaryData);
     console.log("Salary data saved successfully");
     generatePDF(salaryData);
   } catch (error) {
     console.error("Error creating salary slip: ", error);
     alert("Failed to save salary data. Please try again.");
   }
 };

 //generate pdf

 const generatePDF = (data) => {
  try {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [148, 230],
    });

    // Header
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Hero Cleaning Services", 10, 15);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("20/5A, Frazer Av. Moratuwa.", 10, 22);

    // Initialize Y Position
    let yPos = 30;
    const spacing = 7;

    // Helper function to check page overflow
    const checkPageOverflow = () => {
      if (yPos > 220) {
        doc.addPage();
        yPos = 10; // Reset Y position
      }
    };

    // Ensure all numeric data is converted to numbers
    const safeToFixed = (value, decimals = 2) =>
      (parseFloat(value) || 0).toFixed(decimals);



  // Employee Details
  const valueX = 60; // Fixed x-position for all values

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);

      // Get current year
      const currentYear = new Date().getFullYear();

      doc.text("Salary Month:", 10, yPos);
      // If salaryMonth exists, append current year, otherwise show just "-"
      doc.text(`${data.salaryMonth ? `${data.salaryMonth} ${currentYear}` : "-"}`, valueX, yPos);
      checkPageOverflow();

    
    doc.text("Employee Name:", 10, (yPos += spacing));
    doc.text(`${data.employeeName || "-"}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("EPF No:", 10, (yPos += spacing));
    doc.text(`${data.epfNo || "-"}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("NIC No:", 10, (yPos += spacing));
    doc.text(`${data.nicNo || "-"}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Designation:", 10, (yPos += spacing));
    doc.text(`${data.designation || "-"}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Site:", 10, (yPos += spacing));
    doc.text(`${data.site || "-"}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Worked Days:", 10, (yPos += spacing));
    doc.text(`${data.workedDays || "-"}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Site Rate: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.siteRate)}`, valueX, yPos);
    checkPageOverflow();

    // Earnings Section
    yPos += 7.5;
    
    doc.setFont("helvetica", "bold");
    
    doc.text("EPF SALARY: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.epfSalary)}`, valueX, yPos);
    doc.line(10, yPos + 2, 50, yPos + 2);
    checkPageOverflow();

    doc.setFont("helvetica", "normal");
    doc.text("Overtime (OT): ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.ot)}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Site Specific Allowance: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.siteAllowance)}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Daily Allowance: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.dailyAllowance)}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Other Allowance: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.otherAllowance)}`, valueX, yPos);
    checkPageOverflow();
    
  



    // Gross Salary
    yPos += 5;

    doc.setFont("helvetica", "bold");
    
    doc.text("GROSS SALARY: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.grossSalary)}`, valueX, yPos);
    doc.line(10, yPos + 2, 50, yPos + 2);
    checkPageOverflow();

    doc.setFont("helvetica", "normal");
    doc.text("EPF 8%: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.epf8)}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Salary Advance: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.salaryAdvance)}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("Uniform Deduction: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.uniformDeduction)}`, valueX, yPos);
    checkPageOverflow();
    
  

    // Net Salary
    yPos += 5;

    doc.setFont("helvetica", "bold");
    
    doc.text("NET SALARY: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.netSalary)}`, valueX, yPos);
    doc.line(10, yPos + 2, 50, yPos + 2);
    checkPageOverflow();

    doc.setFont("helvetica", "normal");
    doc.text("EPF 12%: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.epf12)}`, valueX, yPos);
    checkPageOverflow();
    
    doc.text("ETF 3%: ", 10, (yPos += spacing));
    doc.text(`${safeToFixed(data.etf3)}`, valueX, yPos);
    checkPageOverflow();
    
   
    // Payment Method
    yPos += 5;
    doc.setFont("helvetica", "normal");
    doc.text(`Payment Method: ${(data.paymentMethod)}`, 10, (yPos += spacing));
    
    yPos += 5;
    doc.setFont("helvetica", "normal");
    doc.text("As per your instructions your salary will be paid in cash: .....................", 10, yPos);
    checkPageOverflow();


    yPos += 5;
    doc.setFont("helvetica", "normal");
    doc.text("or", 10, yPos);
    checkPageOverflow();



    yPos += 5;
    doc.setFont("helvetica", "normal");
    doc.text("Salary to Bank", 10, yPos);
    checkPageOverflow(); 
    yPos += 4;
    doc.text("Bank Name: .................. ", 10, yPos);
    checkPageOverflow(); 
    yPos += 4;
    doc.text("Account No: .................. ", 10, yPos);
    checkPageOverflow(); 
    


    // Save PDF
    doc.save(`SalarySlip-${data.salaryMonth || "Unknown"}-${data.employeeName || "Employee"}.pdf`);
    alert("Salary Slip Downloaded Successfully!");
  } catch (error) {
    console.error("Error generating PDF: ", error);
    alert("Error generating salary slip PDF. Please try again.");
  }
};











 // Add these state declarations at the top of your component
const [doNo, setDoNo] = useState("");
const [deliveryTo, setDeliveryTo] = useState("");
const [deliveryDate, setDeliveryDate] = useState(null);
const [deliveryGarbageBagS, setDeliveryGarbageBagS] = useState(0);
const [deliveryGarbageBagL, setDeliveryGarbageBagL] = useState(0);
const [deliveryGarbageBagXL, setDeliveryGarbageBagXL] = useState(0);
const [deliveryBleachingPowder, setDeliveryBleachingPowder] = useState(0);
const [deliveryComfortLiquid, setDeliveryComfortLiquid] = useState(0);
const [deliveryAbrasiveCream, setDeliveryAbrasiveCream] = useState(0);
const [deliveryBrooms, setDeliveryBrooms] = useState(0);
const [deliveryMops, setDeliveryMops] = useState(0);
const [deliveryMopBuckets, setDeliveryMopBuckets] = useState(0);
const [deliveryGlassSqueegee, setDeliveryGlassSqueegee] = useState(0);
const [deliveryFloorSqueegee, setDeliveryFloorSqueegee] = useState(0);
const [deliverySprayCans, setDeliverySprayCans] = useState(0);
const [deliveryDustpans, setDeliveryDustpans] = useState(0);
const [deliveryToiletBrush, setDeliveryToiletBrush] = useState(0);
const [deliveryGloves, setDeliveryGloves] = useState(0);
const [deliveryOldNewspaper, setDeliveryOldNewspaper] = useState(0);
const [deliveryVacuumCleaner, setDeliveryVacuumCleaner] = useState(0);
const [deliveryAirFreshenerLiquid, setDeliveryAirFreshenerLiquid] = useState(0);
const [deliveryDisinfectantFloral, setDeliveryDisinfectantFloral] = useState(0);
const [deliveryDisinfectantCitral, setDeliveryDisinfectantCitral] = useState(0);
const [deliveryDetergentLiquid, setDeliveryDetergentLiquid] = useState(0);
const [deliveryTbCleaner, setDeliveryTbCleaner] = useState(0);
const [deliveryGlassCleaner, setDeliveryGlassCleaner] = useState(0);
const [deliveryDettol, setDeliveryDettol] = useState(0);
const [deliveryDusters, setDeliveryDusters] = useState(0);
const [deliveryAfBlocks, setDeliveryAfBlocks] = useState(0);
const [deliveryUrinalTablets, setDeliveryUrinalTablets] = useState(0);


// 03 create delivery order
// Delivery Order Handler
const handleCreateDeliveryOrder = async () => {
  try {
    // Create delivery order data object
    const deliveryData = {
      doNo,
      deliveryTo,
      deliveryDate, ////////////////////////////////////////////////////////////////////////////////////////////////
      items: {
        detergentLiquid: deliveryDetergentLiquid,
        disinfectantFloral: deliveryDisinfectantFloral,
        disinfectantCitral: deliveryDisinfectantCitral,
        tbCleaner: deliveryTbCleaner,
        airFreshenerLiquid: deliveryAirFreshenerLiquid,
        glassCleaner: deliveryGlassCleaner,
        dettol: deliveryDettol,
        urinalTablets: deliveryUrinalTablets,
        afBlocks: deliveryAfBlocks,
        dusters: deliveryDusters,
        garbageBagS: deliveryGarbageBagS,
        garbageBagL: deliveryGarbageBagL,
        garbageBagXL: deliveryGarbageBagXL,
        bleachingPowder: deliveryBleachingPowder,
        comfortLiquid: deliveryComfortLiquid, 
        abrasiveCream: deliveryAbrasiveCream,
        brooms: deliveryBrooms,
        mops: deliveryMops,
        mopBuckets: deliveryMopBuckets,
        glassSqueegee: deliveryGlassSqueegee,
        floorSqueegee: deliveryFloorSqueegee,
        sprayCans: deliverySprayCans,
        dustpans: deliveryDustpans,
        toiletBrush: deliveryToiletBrush,
        gloves: deliveryGloves,
        oldNewspaper: deliveryOldNewspaper,
        vacuumCleaner: deliveryVacuumCleaner,

      
      
      },
      createdAt: new Date()
    };

    // Save to Firestore
    await addDoc(collection(db, "deliveryOrders"), deliveryData);
    
    // Generate PDF
    generateDeliveryOrderPDF(deliveryData);
    
    alert("Delivery order created successfully!");
    
    // Reset form
    setDeliveryTo("");
    // Reset all delivery item states to 0
    setDeliveryGarbageBagS(0);
    setDeliveryGarbageBagL(0);
    setDeliveryGarbageBagXL(0);
    setDeliveryBleachingPowder(0);
    setDeliveryComfortLiquid(0);
    setDeliveryAbrasiveCream(0);
    setDeliveryBrooms(0);
    setDeliveryMops(0);
    setDeliveryMopBuckets(0);
    setDeliveryGlassSqueegee(0);
    setDeliveryFloorSqueegee(0);
    setDeliverySprayCans(0);
    setDeliveryDustpans(0);
    setDeliveryToiletBrush(0);
    setDeliveryGloves(0);
    setDeliveryOldNewspaper(0);
    setDeliveryVacuumCleaner(0);
    setDeliveryAirFreshenerLiquid(0);
    setDeliveryDisinfectantFloral(0);
    setDeliveryDisinfectantCitral(0);
    setDeliveryDetergentLiquid(0);
    setDeliveryTbCleaner(0);
    setDeliveryGlassCleaner(0);
    setDeliveryDettol(0);
    setDeliveryDusters(0);
    setDeliveryAfBlocks(0);
    setDeliveryUrinalTablets(0);
    
    
  } catch (error) {
    console.error("Error creating delivery order:", error);
    alert("Failed to create delivery order: " + error.message);
  }
};




// PDF Generation Function
const generateDeliveryOrderPDF = (deliveryData) => {
  const formattedDate = deliveryData.deliveryDate 
    ? deliveryData.deliveryDate.toISOString() 
    : 'No date selected';

  const doc = new jsPDF();
  const logo = "/hero.png"; // Ensure this path is correct

  // --- Header ---
  doc.setFillColor(21, 27, 84);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 30, "F"); // Adjusted height for A5 landscape
  doc.addImage(logo, "PNG", 10, 5, 20, 20);
  doc.setFontSize(14);
  doc.setTextColor(255, 255, 255);
  doc.text("HERO CLEANING SERVICES", 80, 12);
  doc.setFontSize(10);
  doc.text("No.20/5 A, Frazer Avenue, 1st Lane, Moratuwa", 80, 18);
  doc.text("Reg: W/H 14179", 80, 24);

  // PDF Header
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(18);
  // doc.text("DELIVERY ORDER", 105, 30, null, null, 'center');

// Set the position and size of the box
const x = 80; // X position
const y = 35; // Y position
const width = 70; // Width of the box
const height = 10; // Height of the box

// Draw the rectangle (box)
doc.rect(x, y, width, height);
doc.setFont(undefined, 'bold');
// Add the text inside the box
doc.text("DELIVERY ORDER", x + width / 2, y + height / 2 + 2, { align: 'center' });
doc.setFont(undefined, 'normal');
// Save or preview the document
doc.save("document.pdf");

doc.setFont(undefined, 'bold');
  doc.setFontSize(12);
  doc.text(`D. O. NO: ${deliveryData.doNo}`, 15, 50)
  doc.text(`Delivery To: ${deliveryData.deliveryTo}`, 15, 55);
  doc.text(`Date: ${new Date(deliveryData.deliveryDate).toLocaleDateString()}`, 15, 60);
  

  doc.setFont(undefined, 'normal');

  // Items Table
  let yPosition = 80;
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text("DESCRIPTION", 15, yPosition);
  doc.text("QTY.ISSUED", 150, yPosition, null, null, 'right');
  doc.line(15, yPosition + 2, 195, yPosition + 2);
  yPosition += 10;
  
  doc.setFont(undefined, 'normal');

  const labelMap = {
    detergentLiquid: "Detergent Liquid (L)",
    disinfectantFloral: "Floral Disinfectant (L)",
    disinfectantCitral: "Pinol Disinfectant (L)",
    tbCleaner: "Toilet Bowl Cleaner (L)",
    airFreshenerLiquid: "Air Freshener Liquid (L)",
    glassCleaner: "Glass Cleaner (L)",
    dettol: "Dettol (ml)",
    urinalTablets: "Urinal Tablets (Jumbo Size)",
    afBlocks: "Air Freshener Blocks (Pieces)",
    dusters: "Dusters (Pieces)",
    garbageBagS: "Garbage Bag (S)",
    garbageBagL: "Garbage Bag (L)",
    garbageBagXL: "Garbage Bag (XL)",
    bleachingPowder: "Bleaching Powder (g)",
    comfortLiquid: "Comfort Liquid (L)",
    abrasiveCream: "Abrasive Cream (ml)",
    brooms: "Brooms",
    mops: "Mops",
    mopBuckets: "Mop Buckets",
    glassSqueegee: "Glass Squeegee",
    floorSqueegee: "Floor Squeegee",
    sprayCans: "Spray Cans",
    dustpans: "Dustpans",
    toiletBrush: "Toilet Brush",
    gloves: "Gloves",
    oldNewspaper: "Old Newspaper (kg)",
    vacuumCleaner: "Vacuum Cleaner",


  

 
  };
  


  // Add all items to PDF
  Object.entries(deliveryData.items).forEach(([item, quantity]) => {
    if (quantity > 0) {
      const label = labelMap[item] || item; // fallback in case label missing
      doc.text(label, 15, yPosition);
      doc.text(quantity.toString(), 150, yPosition, null, null, 'right');
      yPosition += 6;
    }
  });
  
  // Footer
  doc.setFontSize(10);
  doc.text("Checked by", 50, 280);
  doc.text("Received by", 150, 280);
  doc.line(50, 275, 80, 275); // Signature line
  doc.line(150, 275, 180, 275); // Signature line


  // --- Footer ---
  doc.setFillColor(255, 170, 29);
  doc.rect(0, doc.internal.pageSize.getHeight() - 15, doc.internal.pageSize.getWidth(), 15, "F");
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);
  doc.text("Contact No: 075 90 66 636 / 077 6066 636", 10, doc.internal.pageSize.getHeight() - 7);
  doc.text("Email: 1heroclean@gmail.com", 10, doc.internal.pageSize.getHeight() - 3);
  

  // Save PDF
  doc.save(`DeliveryOrder_${deliveryData.deliveryTo}_${deliveryData.deliveryDate.toISOString().split('T')[0]}.pdf`);
};



















  
  
//view invoices
const [invoices, setInvoices] = useState([]); // State to store invoices

useEffect(() => {
  const fetchInvoices = async () => {
    try {
      // Get a reference to the invoices collection
      const invoicesCollection = collection(db, "invoices");
      
      // Fetch all documents from the collection
      const invoiceSnapshot = await getDocs(invoicesCollection);
      
      // Map the data to an array of invoice objects
      const invoiceList = invoiceSnapshot.docs.map(doc => ({
        id: doc.id, // Unique ID for each invoice document
        ...doc.data(), // All the data from the document
      }));
      
      // Set the invoices state with the fetched data
      setInvoices(invoiceList);
    } catch (error) {
      console.error("Error fetching invoices: ", error);
    }
  };

  fetchInvoices(); // Call the function to fetch invoices
}, []); // Empty dependency array ensures this runs once when the component mounts


// download excel sheet 
const handleDownload = () => {
  if (invoices.length === 0) {
    alert("No invoices to download.");
    return;
  }

  // Convert invoice data to worksheet
  const worksheet = XLSX.utils.json_to_sheet(invoices);
  
  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  // Trigger download
  XLSX.writeFile(workbook, "invoices.xlsx");
};

// 1. Download PDF for a specific invoice
const handleDownloadPdf = (invoice) => {
  // Create a PDF with A5 landscape size
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [210, 148], // A5 in landscape mode
  });

  const logo = "/hero.png"; // Ensure this path is correct

  // --- Header ---
  doc.setFillColor(21, 27, 84);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), 30, "F");
  doc.addImage(logo, "PNG", 10, 5, 20, 20);
  doc.setFontSize(14);
  doc.setTextColor(255, 255, 255);
  doc.text("HERO CLEANING SERVICES", 80, 12);
  doc.setFontSize(10);
  doc.text("No.20/5 A, Frazer Avenue, 1st Lane, Moratuwa", 80, 18);
  doc.text("Reg: W/H 14179", 80, 24);

  // --- INVOICE Title ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text("INVOICE", doc.internal.pageSize.getWidth() / 2, 40, { align: "center" });

  // --- Invoice Details ---
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text("To:", 10, 55);

  // Split the address by newlines and print each line separately
  const addressLines = invoice.to.split('\n');
  addressLines.forEach((line, index) => {
    doc.text(line, 20, 55 + (index * 5));
  });

  doc.text(`Invoice: ${invoice.invoiceNo}`, doc.internal.pageSize.getWidth() - 10, 55, { align: "right" });
  
  // Format the date as DD-MM-YYYY
  const formattedDate = formatDate(invoice.date);
  doc.text(
    `Date: ${formattedDate}`,
    doc.internal.pageSize.getWidth() - 10,
    62,
    { align: "right" }
  );

  // --- Table ---
  let currentY = 75;
  doc.line(10, currentY, doc.internal.pageSize.getWidth() - 10, currentY);
  currentY += 7;

  // Table Headers
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("Description", 10, currentY);
  doc.text("Amount", doc.internal.pageSize.getWidth() - 10, currentY, { align: "right" });

  currentY += 7;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  currentY += 10; 
  doc.text(invoice.description, 10, currentY);
  doc.text(`Rs.${invoice.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, currentY, { align: "right" });

  currentY += 12;

  // Deduct Amount
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Deduction Amount", 10, currentY);
  doc.text(`Rs.${invoice.deductAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, currentY, { align: "right" });

  currentY += 7;

  // Total Amount
  doc.setFont("helvetica", "bold");
  doc.text("Total Amount", 10, currentY + 10);
  doc.text(`Rs.${invoice.totalAmount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, currentY + 10, { align: "right" });
  doc.setFont("helvetica", "normal");

  // --- Footer ---
  doc.setFillColor(255, 170, 29);
  doc.rect(0, doc.internal.pageSize.getHeight() - 15, doc.internal.pageSize.getWidth(), 15, "F");
  doc.setFontSize(9);
  doc.setTextColor(0, 0, 0);
  doc.text("Contact No: 075 90 66 636 / 077 6066 636", 10, doc.internal.pageSize.getHeight() - 7);
  doc.text("Email: 1heroclean@gmail.com", 10, doc.internal.pageSize.getHeight() - 3);

  // Save the PDF
  doc.save(`Invoice-${invoice.invoiceNo}.pdf`);
};

// 2. Delete an invoice record
const handleDeleteInvoice = async (invoiceId) => {
  if (window.confirm("Are you sure you want to delete this invoice?")) {
    try {
      await deleteDoc(doc(db, "invoices", invoiceId));
      // Update the invoices list by removing the deleted invoice
      setInvoices(invoices.filter(invoice => invoice.id !== invoiceId));
      alert("Invoice deleted successfully!");
    } catch (error) {
      console.error("Error deleting invoice: ", error);
      alert("Failed to delete invoice.");
    }
  }
};

// Helper function to format date as DD-MM-YYYY
function formatDate(dateInput) {
  const date = new Date(dateInput);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}












  // Handle Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };
  

  // Example: Fetch user details (you might want to update this based on your logic)
  useEffect(() => {
    // Logic to fetch user details from Firestore or Firebase Auth
    const fetchUserDetails = async () => {
      const user = auth.currentUser;
      if (user) {
        // If the user is logged in, set userDetails (you can fetch more details from Firestore if needed)
        setUserDetails({
          name: user.displayName,
          email: user.email,
        });
      }
    };

    fetchUserDetails();
  }, [auth]);







const [salaries, setSalaries] = useState([]);
const [searchTerm, setSearchTerm] = useState("");

// Fetch previous salary records from Firestore
useEffect(() => {
  const fetchSalaries = async () => {
    try {
      const salaryCollection = collection(db, "salaries");
      const salarySnapshot = await getDocs(salaryCollection);
      const salaryList = salarySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      // Sort by month in descending order (newest first)
      const sortedSalaries = salaryList.sort((a, b) => {
        const months = ["January", "February", "March", "April", "May", "June", 
                       "July", "August", "September", "October", "November", "December"];
        return months.indexOf(b.salaryMonth) - months.indexOf(a.salaryMonth);
      });
      
      setSalaries(sortedSalaries);
    } catch (error) {
      console.error("Error fetching salaries: ", error);
    }
  };

  fetchSalaries();
}, []);

// Filter salaries based on search term
const filteredSalaries = salaries.filter(salary => {
  const searchLower = searchTerm.toLowerCase();
  return (
    (salary.employeeName && salary.employeeName.toLowerCase().includes(searchLower)) ||
    (salary.branch && salary.branch.toLowerCase().includes(searchLower))
  );
});

// Format timestamp
const formatTimestamp = (timestamp) => {
  const date = timestamp.toDate();
  return `${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`;
};

// Download salary as xlsx file
const handleDownloadSalaries = () => {
  const dataToExport = searchTerm ? filteredSalaries : salaries;
  
  if (dataToExport.length === 0) {
    alert("No salary data to download.");
    return;
  }

  const formattedData = dataToExport.map((salary) => {
    const formattedSalary = { ...salary };
    if (formattedSalary.timestamp) {
      formattedSalary.timestamp = formatTimestamp(formattedSalary.timestamp);
    }
    return formattedSalary;
  });

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Salaries");
  XLSX.writeFile(workbook, "salary_records.xlsx");
};

// Delete salary record
const handleDeleteSalary = async (id) => {
  if (window.confirm("Are you sure you want to delete this salary record?")) {
    try {
      await deleteDoc(doc(db, "salaries", id));
      setSalaries(salaries.filter(salary => salary.id !== id));
      alert("Salary record deleted successfully");
    } catch (error) {
      console.error("Error deleting salary: ", error);
      alert("Failed to delete salary record");
    }
  }
};




//   const [salaries, setSalaries] = useState([]);

//   // Fetch previous salary records from Firestore
//   useEffect(() => {
//     const fetchSalaries = async () => {
//       try {
//         const salaryCollection = collection(db, "salaries");
//         const salarySnapshot = await getDocs(salaryCollection);
//         const salaryList = salarySnapshot.docs.map((doc) => ({
//           id: doc.id,
//           ...doc.data(),
//         }));
//         setSalaries(salaryList);
//       } catch (error) {
//         console.error("Error fetching salaries: ", error);
//       }
//     };

//     fetchSalaries();
//   }, []);

//   // Function to format the timestamp
//   const formatTimestamp = (timestamp) => {
//     const date = timestamp.toDate();
//     return `${date.toLocaleDateString()} at ${date.toLocaleTimeString()}`;
//   };

// //downloas salary as xlsx file
// const handleDownloadSalaries = () => {
//   if (salaries.length === 0) {
//     alert("No salary data to download.");
//     return;
//   }

//   // Format salary data (e.g., convert Firestore Timestamp)
//   const formattedData = salaries.map((salary) => {
//     const formattedSalary = { ...salary };

//     // Convert Firestore Timestamp to readable string
//     if (formattedSalary.timestamp) {
//       formattedSalary.timestamp = formatTimestamp(formattedSalary.timestamp);
//     }

//     return formattedSalary;
//   });

//   // Create worksheet from JSON
//   const worksheet = XLSX.utils.json_to_sheet(formattedData);

//   // Create workbook and append worksheet
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Salaries");

//   // Export as Excel file
//   XLSX.writeFile(workbook, "salary_records.xlsx");
// };







//stock management
 // State for all fields, including the new ones
 const [year, setYear] = useState("");
 const [month, setMonth] = useState("");
 const [garbageBagS, setGarbageBagS] = useState("");
 const [garbageBagL, setGarbageBagL] = useState("");
 const [garbageBagXL, setGarbageBagXL] = useState("");
 const [bleachingPowder, setBleachingPowder] = useState("");
 const [comfortLiquid, setComfortLiquid] = useState("");
 const [abrasiveCream, setAbrasiveCream] = useState("");
 const [brooms, setBrooms] = useState("");
 const [mops, setMops] = useState("");
 const [mopBuckets, setMopBuckets] = useState("");
 const [glassSqueegee, setGlassSqueegee] = useState("");
 const [floorSqueegee, setFloorSqueegee] = useState("");
 const [sprayCans, setSprayCans] = useState("");
 const [dustpans, setDustpans] = useState("");
 const [toiletBrush, setToiletBrush] = useState("");
 const [gloves, setGloves] = useState("");
 const [oldNewspaper, setOldNewspaper] = useState("");
 const [vacuumCleaner, setVacuumCleaner] = useState("");
 // New fields
 const [airFreshenerLiquid, setAirFreshenerLiquid] = useState("");
 const [disinfectantFloral, setDisinfectantFloral] = useState("");
 const [disinfectantCitral, setDisinfectantCitral] = useState("");
 const [detergentLiquid, setDetergentLiquid] = useState("");
 const [tbCleaner, setTbCleaner] = useState("");
 const [glassCleaner, setGlassCleaner] = useState("");
 const [dettol, setDettol] = useState("");
 const [dusters, setDusters] = useState("");
 const [afBlocks, setAfBlocks] = useState("");
 const [urinalTablets, setUrinalTablets] = useState("");

 const handleSubmit = async () => {
   const stockData = {
     year,
     month,
     garbageBagS,
     garbageBagL,
     garbageBagXL,
     bleachingPowder,
     comfortLiquid,
     abrasiveCream,
     brooms,
     mops,
     mopBuckets,
     glassSqueegee,
     floorSqueegee,
     sprayCans,
     dustpans,
     toiletBrush,
     gloves,
     oldNewspaper,
     vacuumCleaner,
     airFreshenerLiquid,
     disinfectantFloral,
     disinfectantCitral,
     detergentLiquid,
     tbCleaner,
     glassCleaner,
     dettol,
     dusters,
     afBlocks,
     urinalTablets
   };

   try {
     // Save the data to Firestore 'stock' collection
     await addDoc(collection(db, "stock"), stockData);
     alert("Stock data saved successfully!");
     
     // Clear the form fields after submission
     setYear("");
     setMonth("");
     setGarbageBagS("");
     setGarbageBagL("");
     setGarbageBagXL("");
     setBleachingPowder("");
     setComfortLiquid("");
     setAbrasiveCream("");
     setBrooms("");
     setMops("");
     setMopBuckets("");
     setGlassSqueegee("");
     setFloorSqueegee("");
     setSprayCans("");
     setDustpans("");
     setToiletBrush("");
     setGloves("");
     setOldNewspaper("");
     setVacuumCleaner("");
     // Reset the new fields as well
     setAirFreshenerLiquid("");
     setDisinfectantFloral("");
     setDisinfectantCitral("");
     setDetergentLiquid("");
     setTbCleaner("");
     setGlassCleaner("");
     setDettol("");
     setDusters("");
     setAfBlocks("");
     setUrinalTablets("");
   } catch (error) {
     alert("Error saving stock data: ", error);
   }
 };






// //view stock according to the year and month

// const [stockData, setStockData] = useState([]);

// useEffect(() => {
//   // Fetching stock data from Firebase on component mount
//   const fetchStockData = async () => {
//     const querySnapshot = await getDocs(collection(db, "stock"));
//     const stockList = querySnapshot.docs.map((doc) => doc.data());
//     setStockData(stockList);
//   };

//   fetchStockData();
// }, []);

// // Function to sort stock data by year and month
// const sortStockData = (data) => {
//   return data.sort((a, b) => {
//     const yearComparison = a.year - b.year;
//     if (yearComparison === 0) {
//       const months = [
//         "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
//       ];
//       return months.indexOf(a.month) - months.indexOf(b.month);
//     }
//     return yearComparison;
//   });
// };

// // Sorted stock data
// const sortedStockData = sortStockData(stockData);




const [selectedYear, setSelectedYear] = useState("");
const [selectedMonth, setSelectedMonth] = useState("");
const [availableStock, setAvailableStock] = useState(null);

// Function to calculate available stock
const calculateAvailableStock = async (year, month) => {
  try {
    // Get stock data for the selected year and month
    const stockQuery = query(
      collection(db, "stock"),
      where("year", "==", year),
      where("month", "==", month)
    );
    const stockSnapshot = await getDocs(stockQuery);
    
    if (stockSnapshot.empty) {
      setAvailableStock(null);
      return;
    }
    
    const stockData = stockSnapshot.docs[0].data();
    
    // Get all delivery orders for the selected year and month
    const deliveryQuery = query(
      collection(db, "deliveryOrders"),
      where("year", "==", year),
      where("month", "==", month)
    );
    const deliverySnapshot = await getDocs(deliveryQuery);
    
    // Initialize available stock with the stock data
    const calculatedStock = { ...stockData };
    
    // Subtract all delivery orders from the stock
    deliverySnapshot.forEach((doc) => {
      const deliveryData = doc.data().items;
      
      for (const item in deliveryData) {
        if (calculatedStock[item]) {
          calculatedStock[item] -= deliveryData[item];
          // Ensure stock doesn't go negative
          if (calculatedStock[item] < 0) calculatedStock[item] = 0;
        }
      }
    });
    
    setAvailableStock(calculatedStock);
  } catch (error) {
    console.error("Error calculating available stock:", error);
    alert("Failed to calculate available stock: " + error.message);
  }
};

// Handler for viewing available stock
const handleViewAvailableStock = () => {
  if (!selectedYear || !selectedMonth) {
    alert("Please select both year and month");
    return;
  }
  calculateAvailableStock(selectedYear, selectedMonth);
};










  return (


    <div className="hero-dashboard-container">
      {/* Left Sidebar */}
      <div className="lecturer-sidebar">
      <div className="home-content">
              <img
                src="/hero.png" // Assuming the image is in the public folder
                alt="Hero Cleaning Services"
                className="left-panel-image"
              />
              </div>
        <h2 className="lecturer-sidebar-title"> Hero Cleaning services</h2>

        <div className="lecturer-sidebar-list">
          <li onClick={() => setSelectedOption("home")}>Home</li>
          <li onClick={() => setSelectedOption("createInvoice")}>Create Invoice</li>
          <li onClick={() => setSelectedOption("viewInvoice")}>View All Invoices </li>
          <li onClick={() => setSelectedOption("createSalary")}>Create Salary</li>
          <li onClick={() => setSelectedOption("previousSalary")}>View Previous salary</li>
          <li onClick={() => setSelectedOption("stockManagement")}>Stock Management</li>
          <li onClick={() => setSelectedOption("createDeliveryOrder")}>Create Delivery Order</li>
          <li onClick={() => setSelectedOption("viewStock")}>view Available Stock</li>
          <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
      </div>

      {/* Main Panel */}
      <div className="lecturer-panel">
        {selectedOption === "home" && (
          <div className="home-section">
            <div className="left-panel">
              <img
                src="/hero.png" // Assuming the image is in the public folder
                alt="Hero Cleaning Services"
                className="home-image"
              />
              <p className="home-description">
              Hero Cleaning Service is dedicated to providing top-notch cleaning solutions that prioritize both quality and sustainability. With a focus on eco-friendly products and advanced cleaning methods, 
              we aim to deliver exceptional service while ensuring healthier and safer environments for our clients. Our team is committed to professionalism, 
              reliability, and customer satisfaction, offering tailored cleaning services for homes, offices, and commercial spaces. At Hero Cleaning Service, we believe that a
               clean space enhances well-being, and we strive to make every space spotless while contributing to a cleaner, greener planet.
              </p>
            </div>

            <div className="vision-mission">
              <div className="vision">
                <h2>Our Vision</h2>
                <p>
                To be the leading provider of eco-friendly, reliable, and efficient cleaning solutions, creating cleaner and healthier 
                spaces for our clients while contributing to a sustainable environment.
                </p>
              </div>

              <div className="mission">
                <h2>Our Mission</h2>
                <p>
                Our mission is to deliver exceptional cleaning services with a commitment to quality, professionalism, and customer satisfaction. We use eco-friendly products and 
                innovative techniques to ensure every space is spotless, hygienic, 
                and safe, all while providing unparalleled service to our community.
                </p>
              </div>
            </div>
          </div>
        )}




          {selectedOption === "createInvoice" && userDetails && (
            <div className="student-dashboard-container">
            <div className="lecturer-panel">
              {selectedOption === "createInvoice" && userDetails && (
                <div className="home-section">
                  <h1 className="invoice-heading">Create Invoice</h1>
                  <form className="invoice-form">
                    <div className="form-row-create-invoice">

                      <div className="form-column-create-invoice">
                        <label htmlFor="to">To</label>
                        <select 
                        className="form-column-create-invoice"
                          id="to" 
                          value={to} 
                          onChange={(e) => setTo(e.target.value)} 
                          required
                        >
                          <option value="">Select a recipient</option>

                            <option value={
                            `Cargills Bank H/O\n` +
                            `No 696, Galle Road\n` +
                            `Colombo 03`
                          }>
                            Cargills Bank,Head Office
                          </option>

                          <option value={
                            `Cargills Bank / Meewella Branch\n` +
                            `Meewella Building\n` +
                            `Colombo 04`
                          }>
                         Cargills Bank, Meewella Branch
                          </option>
     
                        </select>
                      </div>

                      <div className="form-column-create-invoice">
                        <label htmlFor="date">Date</label>
                        <input type="date" id="date" value={date} onChange={(e) => setDate(e.target.value)} required />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">

                      <div className="form-column-create-invoice">
                        <label htmlFor="invoiceNo">Invoice No</label>
                        <input type="text" id="invoiceNo" value={invoiceNumber} onChange={(e) => setInvoiceNumber(e.target.value)} required />
                      </div>
                      
            


                      <div className="form-column-create-invoice">
                        <label htmlFor="amount">Fixed Amount</label>
                        <input
                          type="number"
                          id="amount"
                          value={amount}
                          onChange={(e) => {
                            const value = e.target.value;
                            setAmount(value);
                            setTotalAmount(parseFloat(value) - parseFloat(deductAmount) || 0); // Adjust total amount calculation
                          }}
                          required
                        />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="deductAmount">Deduct Amount</label>
                        <input
                          type="number"
                          id="deductAmount"
                          value={deductAmount}
                          onChange={(e) => {
                            const value = e.target.value;
                            setDeductAmount(value);
                            setTotalAmount(parseFloat(amount) - parseFloat(value)); // Adjust total amount calculation
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="description">Description</label>
                        <textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} required />
                      </div>
                    </div>

                    <div className="form-row-create-invoice">
                      <div className="form-column-create-invoice">
                        <label htmlFor="totalAmount">Total Amount</label>
                        <input type="text" id="totalAmount" value={totalAmount} readOnly />
                      </div>
                    </div>

                    <button type="button" onClick={handleCreateInvoice} className="create-button">
                      Create Invoice
                    </button>
                  </form>
                </div>
              )}
            </div>

            </div>
           )}



{selectedOption === "viewInvoice" && (
  <div className="home-section">
    <h1 className="lecturer-awareness-title">View All Invoices</h1>
    <button onClick={handleDownload} className="invoices-excel">
      Download Invoices
    </button>


    
    <div className="invoices-container">
      <table className="invoices-table">
        <thead>
          <tr>
            <th>Invoice Number</th>
            <th>To</th>
            <th>Date</th>
            <th>Description</th>
            <th>Amount</th>
            <th>Deduction Amount</th>
            <th>Total Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {invoices.length > 0 ? (
            invoices.map((invoice) => (
              <tr key={invoice.id}>
                <td>{invoice.invoiceNo}</td>
                <td>{invoice.to}</td>
                <td>{formatDate(invoice.date)}</td>
                <td>{invoice.description}</td>
                <td>Rs.{invoice.amount.toFixed(2)}</td>
                <td>Rs.{invoice.deductAmount.toFixed(2)}</td>
                <td>Rs.{invoice.totalAmount.toFixed(2)}</td>
                <td className="actions-cell">
                  <button 
                    onClick={() => handleDownloadPdf(invoice)}
                    className="download-pdf-btn"
                  >
                    Download PDF
                  </button>
                  <button 
                    onClick={() => handleDeleteInvoice(invoice.id)}
                    className="delete-invoice-btn"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No invoices found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}





        {selectedOption === "createSalary" && (
          <div className="home-section">
                <h1 className="lecturer-panel-title">Create Salary</h1>

                <form className="salary-form" onSubmit={handleGenerateSalary}>
                  <div className="form-row">
                    <div className="form-column">
                      <label htmlFor="employeeName">Employee Name</label>
                      <input
                        type="text"
                        id="employeeName"
                        value={employeeName}
                        onChange={(e) => setEmployeeName(e.target.value)}
                        required
                      />
                    </div>
                    
                    <div className="form-column">
                      <label htmlFor="salaryMonth">Salary Month</label>
                      <select
                        id="salaryMonth"
                        value={salaryMonth}
                        onChange={(e) => setSalaryMonth(e.target.value)}
                        required
                      >
                        {["January", "February", "March", "April", "May", "June", 
                          "July", "August", "September", "October", "November", "December"].map((month) => (
                          <option key={month} value={month}>{month}</option>
                        ))}
                      </select>
                    </div>

                  </div>


              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="epfNo">EPF No</label>
                  <input
                    type="text"
                    id="epfNo"
                    value={epfNo}
                    onChange={(e) => setEpfNo(e.target.value)}
                    required
                  />
                </div>
                <div className="form-column">
                  <label htmlFor="nicNo">NIC No</label>
                  <input
                    type="text"
                    id="nicNo"
                    value={nicNo}
                    onChange={(e) => setNicNo(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="designation">Designation</label>
                  <select value={designation} onChange={(e) => setDesignation(e.target.value)}>
                    <option value="">Select Designation</option>
                    <option value="Trainee Janitor">Trainee Janitor</option>
                    <option value="Janitor">Janitor</option>
                    <option value="Trainee Supervisor">Trainee Supervisor</option>
                    <option value="Supervisor">Supervisor</option>
                  </select>
                </div>

                <div className="form-column">
                  <label htmlFor="site">Site</label>
                  <input
                    type="text"
                    id="site"
                    value={site}
                    onChange={(e) => setSite(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="workedDays">Worked Days</label>
                  <select onChange={(e) => setWorkedDays(Number(e.target.value))}>
                {[...Array(31)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>{i + 1}</option>
                ))}
              </select>
                </div>

                <div className="form-column">
                  <label htmlFor="siteRate">Site Rate</label>
                  <input
                    type="number"
                    id="siteRate"
                    value={siteRate}
                    onChange={(e) => setSiteRate(e.target.value)}
                    required
                  />
                </div>

              </div>
              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="epfSalary">EPF Salary</label>
                  <input
                    type="number"
                    id="epfSalary"
                    value={epfSalary}
                    onChange={(e) => setEpfSalary(e.target.value)}
                    required
                  />
                </div>

                <div className="form-column">
                  <label htmlFor="ot">OT (Overtime)</label>
                  <input
                    type="number"
                    id="ot"
                    value={ot}
                    onChange={(e) => setOt(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="siteAllowance">Site Specific Allowance</label>
                  <input
                    type="number"
                    id="siteAllowance"
                    value={siteAllowance}
                    onChange={(e) => setSiteAllowance(e.target.value)}
                    required
                  />
                </div>
                <div className="form-column">
                  <label htmlFor="dailyAllowance">Daily Allowance</label>
                  <input
                    type="number"
                    id="dailyAllowance"
                    value={dailyAllowance}
                    onChange={(e) => setDailyAllowance(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="otherAllowance">Other Allowance</label>
                  <input
                    type="number"
                    id="otherAllowance"
                    value={otherAllowance}
                    onChange={(e) => setOtherAllowance(e.target.value)}
                    required
                  />
                </div>
                <div className="form-column">
                  <label htmlFor="grossSalary">Gross Salary</label>
                  <input
                    type="number"
                    id="grossSalary"
                    value={grossSalary}
                    onChange={(e) => setGrossSalary(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
              <div className="form-column">
              <label htmlFor="otHours">OT Hours</label>
              <input type="number" placeholder="OT Hours" onChange={(e) => setOtHours(Number(e.target.value))} />
              </div>

              <div className="form-column">
              <label htmlFor="uniformDeduction">Uniform Deduction</label>
              <input type="number" placeholder="Uniform Deduction" onChange={(e) => setUniformDeduction(Number(e.target.value))} />
              </div>
              </div>

          

              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="epf8">EPF 8%</label>
                  <input
                    type="number"
                    id="epf8"
                    value={epf8}
                    onChange={(e) => setEpf8(e.target.value)}
                    required
                  />
                </div>
                <div className="form-column">
                  <label htmlFor="salaryAdvance">Salary Advance</label>
                  <input type="number" placeholder="Salary Advance" onChange={(e) => setSalaryAdvance(Number(e.target.value))} />
                </div>
              </div>

              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="netSalary">Net Salary</label>
                  <input
                    type="number"
                    id="netSalary"
                    value={netSalary}
                    onChange={(e) => setNetSalary(e.target.value)}
                    required
                  />
                </div>
                <div className="form-column">
                  <label htmlFor="epf12">EPF 12%</label>
                  <input
                    type="number"
                    id="epf12"
                    value={epf12}
                    onChange={(e) => setEpf12(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-column">
                  <label htmlFor="etf3">ETF 3%</label>
                  <input
                    type="number"
                    id="etf3"
                    value={etf3}
                    onChange={(e) => setEtf3(e.target.value)}
                    required
                  />
                </div>
                <div className="form-column">
                  <label htmlFor="paymentMethod">Payment Method</label>
                  <select onChange={(e) => setPaymentMethod(e.target.value)}>
                {["Cash", "Bank Deposit"].map((method) => (
                  <option key={method} value={method}>{method}</option>
                ))}
              </select>
                </div>
              </div>

              <button onClick={handleGenerateSalary}>Create Salary Slip</button>
            </form>
          </div>
                )}



                {/* {selectedOption === "previousSalary" && (
            <div className="salary-table-container">
            <h1 className="lecturer-panel-title">View Previous Salary</h1>
            <button onClick={handleDownloadSalaries} className="slary-excel">
              Download Salary Records
            </button>
            <div className="table-wrapper">
              <table className="salary-table">
                <thead>
                  <tr>
                    <th>Employee Name</th>
                    <th>Salary Month</th>
                    <th>Designation</th>
                    <th>Gross Salary</th>
                    <th>Net Salary</th>
                    <th>Payment Method</th>
                    <th>Created At</th>
                    <th>Worked Days</th>
                    <th>EPF No</th>
                    <th>Site</th>
                    <th>Other Allowance</th>
                    <th>OT</th>
                    <th>Site Allowance</th>
                    <th>Salary Advance</th>
                    <th>EPF 8%</th>
                    <th>EPF 12%</th>
                    <th>ETF 3%</th>
                    <th>Site Rate</th>
                    <th>Daily Allowance</th>
                    <th>NIC No</th>
                  </tr>
                </thead>
                <tbody>
                  {salaries.map((salary) => (
                    <tr key={salary.id}>
                      <td>{salary.employeeName || "N/A"}</td>
                      <td>{salary.salaryMonth || "N/A"}</td>
                      <td>{salary.designation || "N/A"}</td>
                      <td>{salary.grossSalary || "N/A"}</td>
                      <td>{salary.netSalary || "N/A"}</td>
                      <td>{salary.paymentMethod || "N/A"}</td>
                      <td>{salary.createdAt ? formatTimestamp(salary.createdAt) : "N/A"}</td>
                      <td>{salary.workedDays || "N/A"}</td>
                      <td>{salary.epfNo || "N/A"}</td>
                      <td>{salary.site || "N/A"}</td>
                      <td>{salary.otherAllowance || "N/A"}</td>
                      <td>{salary.ot || "N/A"}</td>
                      <td>{salary.siteAllowance || "N/A"}</td>
                      <td>{salary.salaryAdvance || "N/A"}</td>
                      <td>{salary.epf8 || "N/A"}</td>
                      <td>{salary.epf12 || "N/A"}</td>
                      <td>{salary.etf3 || "N/A"}</td>
                      <td>{salary.siteRate || "N/A"}</td>
                      <td>{salary.dailyAllowance || "N/A"}</td>
                      <td>{salary.nicNo || "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )} */}


{selectedOption === "previousSalary" && (
  <div className="salary-table-container">
    <h1 className="lecturer-panel-title">View Previous Salary</h1>
    <button onClick={handleDownloadSalaries} className="slary-excel">
      Download Salary Records
    </button>

    <div className="salary-search-container">
      <input
        type="text"
        className="salary-search-input"
        placeholder="Search by employee name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>

    <div className="table-wrapper">
      <table className="salary-table">
        <thead>
          <tr>
            <th>Employee Name</th>
            <th>Salary Month</th>
            <th>Designation</th>
            <th>Gross Salary</th>
            <th>Net Salary</th>
            <th>Payment Method</th>
            <th>Created At</th>
            <th>Worked Days</th>
            <th>EPF No</th>
            <th>Site</th>
            <th>Other Allowance</th>
            <th>OT</th>
            <th>Site Allowance</th>
            <th>Salary Advance</th>
            <th>EPF 8%</th>
            <th>EPF 12%</th>
            <th>ETF 3%</th>
            <th>Site Rate</th>
            <th>Daily Allowance</th>
            <th>NIC No</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredSalaries.length > 0 ? (
            filteredSalaries.map((salary) => (
              <tr key={salary.id}>
                <td>{salary.employeeName || "N/A"}</td>
                <td>{salary.salaryMonth || "N/A"}</td>
                <td>{salary.designation || "N/A"}</td>
                <td>{salary.grossSalary || "N/A"}</td>
                <td>{salary.netSalary || "N/A"}</td>
                <td>{salary.paymentMethod || "N/A"}</td>
                <td>{salary.createdAt ? formatTimestamp(salary.createdAt) : "N/A"}</td>
                <td>{salary.workedDays || "N/A"}</td>
                <td>{salary.epfNo || "N/A"}</td>
                <td>{salary.site || "N/A"}</td>
                <td>{salary.otherAllowance || "N/A"}</td>
                <td>{salary.ot || "N/A"}</td>
                <td>{salary.siteAllowance || "N/A"}</td>
                <td>{salary.salaryAdvance || "N/A"}</td>
                <td>{salary.epf8 || "N/A"}</td>
                <td>{salary.epf12 || "N/A"}</td>
                <td>{salary.etf3 || "N/A"}</td>
                <td>{salary.siteRate || "N/A"}</td>
                <td>{salary.dailyAllowance || "N/A"}</td>
                <td>{salary.nicNo || "N/A"}</td>
                <td className="action-buttons">
                  <button 
                    onClick={() => generatePDF(salary)}
                    className="download-pdf-btn"
                  >
                    Download
                  </button>
                  <button 
                    onClick={() => handleDeleteSalary(salary.id)}
                    className="delete-btn"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="21" style={{ textAlign: 'center' }}>
                {searchTerm ? 'No matching records found' : 'No salary records available'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}





                {selectedOption === "stockManagement" && (
                  <div className="stock-management-container">
                    <h1 className="stock-management-title">Stock Management</h1>

                    <div className="stock-form-group">
                    <label>Year</label>
                    <select
                      className="select-field"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      required
                    >
                      <option value="">Select Year</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                      <option value="2031">2031</option>
                      <option value="2032">2032</option>
                      <option value="2033">2033</option>
                      <option value="2034">2034</option>
                      <option value="2035">2035</option>
                      <option value="2036">2036</option>
                      <option value="2037">2037</option>
                      <option value="2038">2038</option>
                      <option value="2039">2039</option>
                      <option value="2040">2040</option>
                    </select>
                  </div>

                  <div className="stock-form-group">
                    <label>Month</label>
                    <select
                      className="select-field"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      required
                    >
                      <option value="">Select Month</option>
                      <option value="January">January</option>
                      <option value="February">February</option>
                      <option value="March">March</option>
                      <option value="April">April</option>
                      <option value="May">May</option>
                      <option value="June">June</option>
                      <option value="July">July</option>
                      <option value="August">August</option>
                      <option value="September">September</option>
                      <option value="October">October</option>
                      <option value="November">November</option>
                      <option value="December">December</option>
                    </select>
                  </div>

                    {/* Form Fields in Grid */}
                    <div className="stock-form-row">
                      {/* Garbage Bags */}
                      <div className="stock-form-group">
                        <label>Garbage Bags (S)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={garbageBagS}
                          onChange={(e) => setGarbageBagS(e.target.value)}
                        />
                      </div>

                      <div className="stock-form-group">
                        <label>Garbage Bags (L)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={garbageBagL}
                          onChange={(e) => setGarbageBagL(e.target.value)}
                        />
                      </div>

                      <div className="stock-form-group">
                        <label>Garbage Bags (XL)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={garbageBagXL}
                          onChange={(e) => setGarbageBagXL(e.target.value)}
                        />
                      </div>

                      {/* Bleaching Powder */}
                      <div className="stock-form-group">
                        <label>Bleaching Powder (grams)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={bleachingPowder}
                          onChange={(e) => setBleachingPowder(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="stock-form-row">
                      {/* Comfort Liquid */}
                      <div className="stock-form-group">
                        <label>Comfort Liquid (liters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={comfortLiquid}
                          onChange={(e) => setComfortLiquid(e.target.value)}
                        />
                      </div>

                      {/* Abrasive Cream */}
                      <div className="stock-form-group">
                        <label>Abrasive Cream (ml)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={abrasiveCream}
                          onChange={(e) => setAbrasiveCream(e.target.value)}
                        />
                      </div>

                      {/* Brooms */}
                      <div className="stock-form-group">
                        <label>Brooms</label>
                        <input
                          type="number"
                          className="input-field"
                          value={brooms}
                          onChange={(e) => setBrooms(e.target.value)}
                        />
                      </div>

                      {/* Mops */}
                      <div className="stock-form-group">
                        <label>Mops</label>
                        <input
                          type="number"
                          className="input-field"
                          value={mops}
                          onChange={(e) => setMops(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="stock-form-row">
                      {/* Mop Buckets */}
                      <div className="stock-form-group">
                        <label>Mop Buckets</label>
                        <input
                          type="number"
                          className="input-field"
                          value={mopBuckets}
                          onChange={(e) => setMopBuckets(e.target.value)}
                        />
                      </div>

                      {/* Glass Squeegee */}
                      <div className="stock-form-group">
                        <label>Glass Squeegee</label>
                        <input
                          type="number"
                          className="input-field"
                          value={glassSqueegee}
                          onChange={(e) => setGlassSqueegee(e.target.value)}
                        />
                      </div>

                      {/* Floor Squeegee */}
                      <div className="stock-form-group">
                        <label>Floor Squeegee</label>
                        <input
                          type="number"
                          className="input-field"
                          value={floorSqueegee}
                          onChange={(e) => setFloorSqueegee(e.target.value)}
                        />
                      </div>

                      {/* Spray Cans */}
                      <div className="stock-form-group">
                        <label>Spray Cans</label>
                        <input
                          type="number"
                          className="input-field"
                          value={sprayCans}
                          onChange={(e) => setSprayCans(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="stock-form-row">
                      {/* Dustpans */}
                      <div className="stock-form-group">
                        <label>Dustpans</label>
                        <input
                          type="number"
                          className="input-field"
                          value={dustpans}
                          onChange={(e) => setDustpans(e.target.value)}
                        />
                      </div>

                      {/* Toilet Brush */}
                      <div className="stock-form-group">
                        <label>Toilet Brush</label>
                        <input
                          type="number"
                          className="input-field"
                          value={toiletBrush}
                          onChange={(e) => setToiletBrush(e.target.value)}
                        />
                      </div>

                      {/* Gloves */}
                      <div className="stock-form-group">
                        <label>Gloves</label>
                        <input
                          type="number"
                          className="input-field"
                          value={gloves}
                          onChange={(e) => setGloves(e.target.value)}
                        />
                      </div>

                      {/* Old Newspaper */}
                      <div className="stock-form-group">
                        <label>Old Newspaper (kg)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={oldNewspaper}
                          onChange={(e) => setOldNewspaper(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="stock-form-row">
                      {/* Vacuum Cleaner */}
                      <div className="stock-form-group">
                        <label>Vacuum Cleaner Machine</label>
                        <input
                          type="number"
                          className="input-field"
                          value={vacuumCleaner}
                          onChange={(e) => setVacuumCleaner(e.target.value)}
                        />
                      </div>

                      {/* Air Freshener Liquid */}
                      <div className="stock-form-group">
                        <label>Air Freshener Liquid (liters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={airFreshenerLiquid}
                          onChange={(e) => setAirFreshenerLiquid(e.target.value)}
                        />
                      </div>

                      {/* Disinfectant - Floral */}
                      <div className="stock-form-group">
                        <label>Floral Disinfectant (liters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={disinfectantFloral}
                          onChange={(e) => setDisinfectantFloral(e.target.value)}
                        />
                      </div>

                      {/* Disinfectant Citral */}
                      <div className="stock-form-group">
                        <label>Pinol Disinfectant (liters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={disinfectantCitral}
                          onChange={(e) => setDisinfectantCitral(e.target.value)}
                        />
                      </div>


                      {/* Detergent Liquid */}
                      <div className="stock-form-group">
                        <label>Detergent Liquid (liters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={detergentLiquid}
                          onChange={(e) => setDetergentLiquid(e.target.value)}
                        />
                      </div>

                      {/* T.B. Cleaner */}
                      <div className="stock-form-group">
                        <label>T.B. Cleaner (liters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={tbCleaner}
                          onChange={(e) => setTbCleaner(e.target.value)}
                        />
                      </div>

                      <div className="stock-form-group">
                        <label>Glass Cleaner (liters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={glassCleaner}
                          onChange={(e) => setGlassCleaner(e.target.value)}
                        />
                      </div>

                      <div className="stock-form-group">
                        <label>Dettol (mililiters)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={dettol}
                          onChange={(e) => setDettol(e.target.value)}
                        />
                      </div>

                      <div className="stock-form-group">
                        <label>Dusters</label>
                        <input
                          type="number"
                          className="input-field"
                          value={dusters}
                          onChange={(e) => setDusters(e.target.value)}
                        />
                      </div>


                      <div className="stock-form-group">
                        <label>A / F Blocks (Pieces)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={afBlocks}
                          onChange={(e) => setAfBlocks(e.target.value)}
                        />
                      </div>

                      <div className="stock-form-group">
                        <label>Urinal Tablets (Jumbo Size)</label>
                        <input
                          type="number"
                          className="input-field"
                          value={urinalTablets}
                          onChange={(e) => setUrinalTablets(e.target.value)}
                        />
                      </div>

                    </div>

                    {/* Submit Button */}
                    <button className="manage-stock-button" onClick={handleSubmit}>
                      Save Stock Data
                    </button>
                  </div>
                )}




            {selectedOption === "createDeliveryOrder" && (
              <div className="delivery-order-container">
                <h1 className="delivery-order-title">Create Delivery Order</h1>
                
              <div className="delivery-form-scroll">
              <div className="delivery-form-group">
                    <label>D. O. No</label>
                    <input
                      type="text"
                      value={doNo}
                      onChange={(e) =>  setDoNo(e.target.value)}
                      placeholder="Enter D. O. NO"
                      required
                    />
                  </div>
         
                  <div className="delivery-form-group">
                    <label>Delivery To</label>
                    <input
                      type="text"
                      value={deliveryTo}
                      onChange={(e) => setDeliveryTo(e.target.value)}
                      placeholder="Enter delivery destination"
                      required
                    />
                  </div>

                  {/* <input
                    type="date"
                    value={deliveryDate ? deliveryDate.toString().split('T')[0] : ''}
                    onChange={(e) => setDeliveryDate(e.target.value ? new Date(e.target.value) : null)}
                    required
                  /> */}



                  <input
                    type="date"
                    value={deliveryDate ? deliveryDate.toISOString().substring(0, 10) : ''}
                    onChange={(e) => setDeliveryDate(e.target.value ? new Date(e.target.value) : null)}
                    required
                  />




                    {/* <div className="stock-form-group">
                    <label>Date</label>
                    <select
                      className="select-field"
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      required
                    >
                      <option value="">Select Year</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                      <option value="2028">2028</option>
                      <option value="2029">2029</option>
                      <option value="2030">2030</option>
                      <option value="2031">2031</option>
                      <option value="2032">2032</option>
                      <option value="2033">2033</option>
                      <option value="2034">2034</option>
                      <option value="2035">2035</option>
                      <option value="2036">2036</option>
                      <option value="2037">2037</option>
                      <option value="2038">2038</option>
                      <option value="2039">2039</option>
                      <option value="2040">2040</option>
                    </select>
                  </div>

                  <div className="stock-form-group">
                    <label>Month</label>
                    <select
                      className="select-field"
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      required
                    >
                      <option value="">Select Month</option>
                      <option value="January">January</option>
                      <option value="February">February</option>
                      <option value="March">March</option>
                      <option value="April">April</option>
                      <option value="May">May</option>
                      <option value="June">June</option>
                      <option value="July">July</option>
                      <option value="August">August</option>
                      <option value="September">September</option>
                      <option value="October">October</option>
                      <option value="November">November</option>
                      <option value="December">December</option>
                    </select>
                  </div> */}
{/*************************************************************************************************************************/}
   {/* Add all your other delivery items here following the same structure */}




             <div className="delivery-form-row">
                  <div className="delivery-form-group">
                      <label>Detergent Liquid (liters)</label>
                      <input
                        type="number"
                        value={deliveryDetergentLiquid}
                        onChange={(e) => setDeliveryDetergentLiquid(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                      <div className="delivery-form-group">
                        <label>Floral Disinfectant (liters)</label>
                        <input
                          type="number"
                          value={deliveryDisinfectantFloral}
                          onChange={(e) => setDeliveryDisinfectantFloral(Number(e.target.value))}
                          min="0"
                        />
                      </div>

                      <div className="delivery-form-group">
                      <label>Pinol Disinfectant (liters)</label>
                      <input
                        type="number"
                        value={deliveryDisinfectantCitral}
                        onChange={(e) => setDeliveryDisinfectantCitral(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    
                    <div className="delivery-form-group">
                      <label>TB Cleaner (liters)</label>
                      <input
                        type="number"
                        value={deliveryTbCleaner}
                        onChange={(e) => setDeliveryTbCleaner(Number(e.target.value))}
                        min="0"
                      />
                    </div>

             </div>


             <div className="delivery-form-row">
                      <div className="delivery-form-group">
                        <label>Air Freshener Liquid (liters)</label>
                        <input
                          type="number"
                          value={deliveryAirFreshenerLiquid}
                          onChange={(e) => setDeliveryAirFreshenerLiquid(Number(e.target.value))}
                          min="0"
                        />
                      </div>




                   

                    <div className="delivery-form-group">
                      <label>Glass Cleaner (liters)</label>
                      <input
                        type="number"
                        value={deliveryGlassCleaner}
                        onChange={(e) => setDeliveryGlassCleaner(Number(e.target.value))}
                        min="0"
                      />
                    </div>






                  <div className="delivery-form-group">
                      <label>Urinal Tablets (Pieces)</label>
                      <input
                        type="number"
                        value={deliveryUrinalTablets}
                        onChange={(e) => setDeliveryUrinalTablets(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Dettol (mililiters)</label>
                      <input
                        type="number"
                        value={deliveryDettol}
                        onChange={(e) => setDeliveryDettol(Number(e.target.value))}
                        min="0"
                      />
                    </div>
            </div>

            <div className="delivery-form-row">
                    <div className="delivery-form-group">
                      <label>AF Blocks (Pieces)</label>
                      <input
                        type="number"
                        value={deliveryAfBlocks}
                        onChange={(e) => setDeliveryAfBlocks(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Dusters</label>
                      <input
                        type="number"
                        value={deliveryDusters}
                        onChange={(e) => setDeliveryDusters(Number(e.target.value))}
                        min="0"
                      />
                    </div>

              
                    <div className="delivery-form-group">
                      <label>Garbage Bags (S)</label>
                      <input
                        type="number"
                        value={deliveryGarbageBagS}
                        onChange={(e) => setDeliveryGarbageBagS(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Garbage Bags (L)</label>
                      <input
                        type="number"
                        value={deliveryGarbageBagL}
                        onChange={(e) => setDeliveryGarbageBagL(Number(e.target.value))}
                        min="0"
                      />
                    </div>
              </div>


              <div className="delivery-form-row">
                    <div className="delivery-form-group">
                      <label>Garbage Bags (XL)</label>
                      <input
                        type="number"
                        value={deliveryGarbageBagXL}
                        onChange={(e) => setDeliveryGarbageBagXL(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Bleaching Powder (grams)</label>
                      <input
                        type="number"
                        value={deliveryBleachingPowder}
                        onChange={(e) => setDeliveryBleachingPowder(Number(e.target.value))}
                        min="0"
                      />
                    </div>
            

              
                  <div className="delivery-form-group">
                      <label>Comfort Liquid (Liter)</label>
                      <input
                        type="number"
                        value={deliveryComfortLiquid}
                        onChange={(e) => setDeliveryComfortLiquid(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Abrasive Cream (mililiters)</label>
                      <input
                        type="number"
                        value={deliveryAbrasiveCream}
                        onChange={(e) => setDeliveryAbrasiveCream(Number(e.target.value))}
                        min="0"
                      />
                    </div>
                </div>


                <div className="delivery-form-row">
                    <div className="delivery-form-group">
                      <label>Brooms</label>
                      <input
                        type="number"
                        value={deliveryBrooms}
                        onChange={(e) => setDeliveryBrooms(Number(e.target.value))}
                        min="0"
                      />
                  </div>

                    <div className="delivery-form-group">
                      <label>Mops</label>
                      <input
                        type="number"
                        value={deliveryMops}
                        onChange={(e) => setDeliveryMops(Number(e.target.value))}
                        min="0"
                      />
                    </div>
                 
                    

                    <div className="delivery-form-group">
                      <label>Mop Buckets</label>
                      <input
                        type="number"
                        value={deliveryMopBuckets}
                        onChange={(e) => setDeliveryMopBuckets(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Glass Squeegee</label>
                      <input
                        type="number"
                        value={deliveryGlassSqueegee}
                        onChange={(e) => setDeliveryGlassSqueegee(Number(e.target.value))}
                        min="0"
                      />
                    </div>
                </div>


                <div className="delivery-form-row">
                    <div className="delivery-form-group">
                      <label>Floor Squeegee</label>
                      <input
                        type="number"
                        value={deliveryFloorSqueegee}
                        onChange={(e) => setDeliveryFloorSqueegee(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Spray Cans</label>
                      <input
                        type="number"
                        value={deliverySprayCans}
                        onChange={(e) => setDeliverySprayCans(Number(e.target.value))}
                        min="0"
                      />
                    </div>
                 


                <div className="delivery-form-group">
                      <label>Dust pans</label>
                      <input
                        type="number"
                        value={deliveryDustpans}
                        onChange={(e) => setDeliveryDustpans(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Toilet Brush</label>
                      <input
                        type="number"
                        value={deliveryToiletBrush}
                        onChange={(e) => setDeliveryToiletBrush(Number(e.target.value))}
                        min="0"
                      />
                    </div>
              </div>

              <div className="delivery-form-row">
                    <div className="delivery-form-group">
                      <label>Gloves</label>
                      <input
                        type="number"
                        value={deliveryGloves}
                        onChange={(e) => setDeliveryGloves(Number(e.target.value))}
                        min="0"
                      />
                    </div>

                    <div className="delivery-form-group">
                      <label>Spray Cans</label>
                      <input
                        type="number"
                        value={deliverySprayCans}
                        onChange={(e) => setDeliverySprayCans(Number(e.target.value))}
                        min="0"
                      />
                    </div>
            

                  <div className="delivery-form-group">
                        <label>Old Newspaper (kg)</label>
                        <input
                          type="number"
                          value={deliveryOldNewspaper}
                          onChange={(e) => setDeliveryOldNewspaper(Number(e.target.value))}
                          min="0"
                        />
                      </div>

                      <div className="delivery-form-group">
                        <label>Vacuum Cleaner</label>
                        <input
                          type="number"
                          value={deliveryVacuumCleaner}
                          onChange={(e) => setDeliveryVacuumCleaner(Number(e.target.value))}
                          min="0"
                        />
                      </div>

                     

              </div>


                  <button 
                    className="create-delivery-button" 
                    onClick={handleCreateDeliveryOrder}
                  >
                    Create Delivery Order
                  </button>
                </div>
              </div>
            )}




{selectedOption === "viewStock" && ( 
  <div className="stock-management-container">
    <h1 className="stock-management-title">View Available Stock</h1>
    
    {/* Year and Month selection */}
    <div className="stock-filter">
      <select 
        value={selectedYear} 
        onChange={(e) => setSelectedYear(e.target.value)}
        className="stock-select"
      >
        <option value="">Select Year</option>
        <option value="2025">2025</option>
        <option value="2026">2026</option>
        <option value="2027">2027</option>        
        <option value="2028">2028</option>
        <option value="2029">2029</option>
        <option value="2030">2030</option>
        <option value="2031">2031</option>
        <option value="2032">2032</option>
        <option value="2033">2033</option>
        <option value="2034">2034</option>
        <option value="2035">2035</option>
        <option value="2036">2036</option>
        <option value="2037">2037</option>
        <option value="2038">2038</option>
        <option value="2039">2039</option>
        <option value="2040">2040</option>
      </select>
      
      <select 
        value={selectedMonth} 
        onChange={(e) => setSelectedMonth(e.target.value)}
        className="stock-select"
      >
        <option value="">Select Month</option>
        <option value="January">January</option>
        <option value="February">February</option>
        <option value="March">March</option>
        <option value="April">April</option>
        <option value="May">May</option>
        <option value="June">June</option>
        <option value="July">July</option>
        <option value="August">August</option>
        <option value="September">September</option>
        <option value="October">October</option>
        <option value="November">November</option>
        <option value="December">December</option>
      </select>
      
      <button 
        onClick={handleViewAvailableStock}
        className="view-stock-button"
      >
        View Available Stock
      </button>
    </div>
    
    {/* Table to display the available stock data */}
    {availableStock ? (
      <table className="stock-table">
        <thead>
          <tr>
            <th>Year</th>
            <th>Month</th>
            <th>Garbage Bag (S)</th>
            <th>Garbage Bag (L)</th>
            <th>Garbage Bag (XL)</th>
            <th>Bleaching Powder (g)</th>
            <th>Comfort Liquid (L)</th>
            <th>Abrasive Cream (ml)</th>
            <th>Brooms</th>
            <th>Mops</th>
            <th>Mop Buckets</th>
            <th>Glass Squeegee</th>
            <th>Floor Squeegee</th>
            <th>Spray Cans</th>
            <th>Dustpans</th>
            <th>Toilet Brush</th>
            <th>Gloves</th>
            <th>Old Newspaper (kg)</th>
            <th>Vacuum Cleaner</th>
            <th>Air Freshener Liquid (L)</th>
            <th>Disinfectant - Floral (L)</th>
            <th>Disinfectant - Citral (L)</th>
            <th>Detergent Liquid (L)</th>
            <th>T. B. Cleaner (L)</th>
            <th>Glass Cleaner (L)</th>
            <th>Dettol</th>
            <th>Dusters</th>
            <th>A/F Blocks</th>
            <th>Urinal Tablets (Jumbo)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{availableStock.year}</td>
            <td>{availableStock.month}</td>
            <td>{availableStock.garbageBagS}</td>
            <td>{availableStock.garbageBagL}</td>
            <td>{availableStock.garbageBagXL}</td>
            <td>{availableStock.bleachingPowder}</td>
            <td>{availableStock.comfortLiquid}</td>
            <td>{availableStock.abrasiveCream}</td>
            <td>{availableStock.brooms}</td>
            <td>{availableStock.mops}</td>
            <td>{availableStock.mopBuckets}</td>
            <td>{availableStock.glassSqueegee}</td>
            <td>{availableStock.floorSqueegee}</td>
            <td>{availableStock.sprayCans}</td>
            <td>{availableStock.dustpans}</td>
            <td>{availableStock.toiletBrush}</td>
            <td>{availableStock.gloves}</td>
            <td>{availableStock.oldNewspaper}</td>
            <td>{availableStock.vacuumCleaner}</td>
            <td>{availableStock.airFreshenerLiquid}</td>
            <td>{availableStock.disinfectantFloral}</td>
            <td>{availableStock.disinfectantCitral}</td>
            <td>{availableStock.detergentLiquid}</td>
            <td>{availableStock.tbCleaner}</td>
            <td>{availableStock.glassCleaner}</td>
            <td>{availableStock.dettol}</td>
            <td>{availableStock.dusters}</td>
            <td>{availableStock.afBlocks}</td>
            <td>{availableStock.urinalTablets}</td>
          </tr>
        </tbody>
      </table>
    ) : (
      <div className="no-stock-message">
        {selectedYear && selectedMonth ? "No stock data available for the selected month" : "Please select year and month to view available stock"}
      </div>
    )}
  </div>
)}
             
              {/* {selectedOption === "viewStock" && (
                <div className="stock-management-container">
                  <h1 className="stock-management-title">View Available Stock</h1>
              
                  <table className="stock-table">
                    <thead>
                      <tr>
                        <th>Year</th>
                        <th>Month</th>
                        <th>Garbage Bag (S)</th>
                        <th>Garbage Bag (L)</th>
                        <th>Garbage Bag (XL)</th>
                        <th>Bleaching Powder (g)</th>
                        <th>Comfort Liquid (L)</th>
                        <th>Abrasive Cream (ml)</th>
                        <th>Brooms</th>
                        <th>Mops</th>
                        <th>Mop Buckets</th>
                        <th>Glass Squeegee</th>
                        <th>Floor Squeegee</th>
                        <th>Spray Cans</th>
                        <th>Dustpans</th>
                        <th>Toilet Brush</th>
                        <th>Gloves</th>
                        <th>Old Newspaper (kg)</th>
                        <th>Vacuum Cleaner</th>

                        <th>Air Freshener Liquid (L)</th>
                        <th>Disinfectant - Floral (L)</th>
                        <th>Disinfectant - Citral (L)</th>
                        <th>Detergent Liquid (L)</th>
                        <th>T. B. Cleaner (L)</th>
                        <th>Glass Cleaner (L)</th>
                        <th>Dettol</th>
                        <th>Dusters</th>
                        <th>A/F Blocks</th>
                        <th>Urinal Tablets (Jumbo)</th>

                      </tr>
                    </thead>
                    <tbody>
                      {availableStock.length > 0 ? (
                       availableStock.map((data, index) => (
                          <tr key={index}>
                            <td>{data.year}</td>
                            <td>{data.month}</td>
                            <td>{data.garbageBagS}</td>
                            <td>{data.garbageBagL}</td>
                            <td>{data.garbageBagXL}</td>
                            <td>{data.bleachingPowder}</td>
                            <td>{data.comfortLiquid}</td>
                            <td>{data.abrasiveCream}</td>
                            <td>{data.brooms}</td>
                            <td>{data.mops}</td>
                            <td>{data.mopBuckets}</td>
                            <td>{data.glassSqueegee}</td>
                            <td>{data.floorSqueegee}</td>
                            <td>{data.sprayCans}</td>
                            <td>{data.dustpans}</td>
                            <td>{data.toiletBrush}</td>
                            <td>{data.gloves}</td>
                            <td>{data.oldNewspaper}</td>
                            <td>{data.vacuumCleaner}</td>
                            <td>{data.airFreshenerLiquid}</td>
                            <td>{data.disinfectantFloral}</td>
                            <td>{data.disinfectantCitral}</td>
                            <td>{data.detergentLiquid}</td>
                            <td>{data.tbCleaner}</td>
                            <td>{data.glassCleaner}</td>
                            <td>{data.dettol}</td>
                            <td>{data.dusters}</td>
                            <td>{data.afBlocks}</td>
                            <td>{data.urinalTable}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                        <td colSpan="30" style={{ textAlign: "center" }}>
                            No stock data available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )} */}


      </div>
    </div>
  );
};

export default Body;
